import { useParams, useNavigate } from 'react-router-dom';
import { useLead } from '@/hooks/useLeads';
import { Layout } from '@/components/Layout';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { LeadDetailContent } from '@/components/leads/LeadDetailContent';

export default function LeadDetail() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data: lead, isLoading } = useLead(id || null);

  if (isLoading) {
    return (
      <Layout>
        <div className="flex items-center justify-center min-h-[400px]">
          <p className="text-muted-foreground">Loading lead details...</p>
        </div>
      </Layout>
    );
  }

  if (!lead) {
    return (
      <Layout>
        <div className="space-y-4">
          <Button variant="ghost" onClick={() => navigate('/leads')}>
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Leads
          </Button>
          <div className="text-center py-12">
            <p className="text-muted-foreground">Lead not found</p>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="space-y-4 pb-8">
        {/* Back Button */}
        <Button variant="ghost" onClick={() => navigate('/leads')} className="gap-2">
          <ArrowLeft className="h-4 w-4" />
          Back to Leads
        </Button>

        {/* Full Lead Detail Content */}
        <LeadDetailContent 
          lead={lead} 
          isSheet={false} 
          onDeleted={() => navigate('/leads')}
        />
      </div>
    </Layout>
  );
}
